import request from "@/utils/request";

export default function changeState(id,state) {
    return request({
        url: `/storeProduct/agency/changeState/`+id+`/`+state,
        method: 'get',
    })
}
